import type { Role } from '@chipless/shared';

/**
 * 画面の切り替えは URL のクエリ文字列で決める。ルーティングライブラリは持たない。
 *
 * - `/`                          … 入口（卓を立てる / 参加する）
 * - `/?role=display&room=CODE`   … 中央ディスプレイの卓画面
 * - `/?room=CODE`                … プレイヤー端末（QR の参加 URL）
 */

export type Route =
  | { kind: 'landing' }
  | { kind: 'display'; roomCode: string }
  | { kind: 'player'; roomCode: string };

function normalizeCode(value: string | null): string | null {
  if (value === null) return null;
  const code = value.trim().toUpperCase();
  return code === '' ? null : code;
}

export function parseRoute(search: string): Route {
  const params = new URLSearchParams(search);
  const roomCode = normalizeCode(params.get('room'));
  if (roomCode === null) return { kind: 'landing' };
  return params.get('role') === 'display'
    ? { kind: 'display', roomCode }
    : { kind: 'player', roomCode };
}

export function roleOf(route: Route): Role {
  return route.kind === 'display' ? 'DISPLAY' : 'PLAYER';
}

export function displayUrl(roomCode: string): string {
  return `${globalThis.location.origin}/?role=display&room=${roomCode}`;
}

/** QR に載せる参加 URL。 */
export function joinUrl(roomCode: string): string {
  return `${globalThis.location.origin}/?room=${roomCode}`;
}

export function navigate(url: string): void {
  globalThis.location.assign(url);
}
